import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '..'

const InEligibleBankAccout = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <Path
      d="M22.403 7.715 12.838 1.67a.737.737 0 0 0-.787 0L2.486 7.715a.737.737 0 0 0 .394 1.36h19.13a.737.737 0 0 0 .393-1.36ZM20.752 9.516h-2.566a.737.737 0 0 0-.737.737V21.05c0 .407.33.738.737.738h2.566c.407 0 .737-.33.737-.738V10.253a.737.737 0 0 0-.738-.737ZM13.727 9.516h-2.565a.737.737 0 0 0-.737.737V21.05c0 .407.33.738.737.738h2.565c.407 0 .737-.33.737-.738V10.253a.737.737 0 0 0-.737-.737ZM6.652 9.516H4.087a.737.737 0 0 0-.737.737V21.05c0 .407.33.738.737.738h2.565c.407 0 .737-.33.737-.738V10.253a.737.737 0 0 0-.737-.737Z"
      fill="#8CBCFF"
    />
    <Path
      d="M6.652 9.516H5.37v12.27h1.282c.407 0 .737-.33.737-.737V10.253a.737.737 0 0 0-.737-.737Z"
      fill="#6AA9FF"
    />
    <Path
      d="M23.376 7.6H1.513C.756 7.6.14 8.218.14 8.975v1.41c0 .758.616 1.373 1.373 1.373h21.863c.757 0 1.373-.615 1.373-1.372V8.974c0-.757-.616-1.373-1.373-1.373ZM22.01 19.606H2.88a.737.737 0 0 0-.738.737v2.682c0 .407.33.737.737.737h19.13c.407 0 .737-.33.737-.737v-2.682a.737.737 0 0 0-.737-.737Z"
      fill="#54A0FF"
    />
    <Path
      d="M24.012 22.288H.877a.737.737 0 0 0-.737.737v2.682c0 .407.33.737.737.737h23.135c.407 0 .737-.33.737-.737v-2.682a.737.737 0 0 0-.737-.737Z"
      fill="#338DEF"
    />
    <Path
      d="M22.717 8.543a.737.737 0 0 1-.708.532h-9.565v-7.52c.137 0 .274.038.394.115L22.223 7.6l.18.114a.737.737 0 0 1 .314.828ZM20.752 9.516h-1.283v12.27h1.283c.407 0 .737-.33.737-.737V10.253a.737.737 0 0 0-.737-.737ZM13.727 9.516h-1.283v12.27h1.283c.407 0 .737-.33.737-.737V10.253a.737.737 0 0 0-.737-.737Z"
      fill="#6AA9FF"
    />
    <Path
      d="M24.749 8.974v1.41c0 .757-.616 1.373-1.373 1.373H12.444V7.601h10.932c.757 0 1.373.616 1.373 1.373ZM22.746 20.343v2.682c0 .407-.33.737-.737.737h-9.565v-4.156h9.565c.407 0 .737.33.737.737Z"
      fill="#338DEF"
    />
    <Path
      d="M24.749 23.025v2.682c0 .407-.33.737-.737.737H12.444v-4.156h11.568c.407 0 .737.33.737.737Z"
      fill="#338DEF"
    />
    <Path
      d="M25.236 28H12.165a2.385 2.385 0 0 1-2.06-1.19 2.386 2.386 0 0 1 0-2.377l6.536-11.32a2.385 2.385 0 0 1 2.06-1.19c.846 0 1.636.456 2.06 1.19l6.535 11.32a2.386 2.386 0 0 1 0 2.378A2.386 2.386 0 0 1 25.236 28Z"
      fill="#fff"
    />
    <Path
      d="M27.296 26.81a2.386 2.386 0 0 0 0-2.377l-6.536-11.32a2.386 2.386 0 0 0-2.06-1.19V28h6.536c.847 0 1.636-.456 2.06-1.19Z"
      fill="#fff"
    />
    <Path
      d="M12.165 26.478a.859.859 0 0 1-.742-.429.86.86 0 0 1 0-.855l6.536-11.32a.859.859 0 0 1 .741-.428c.305 0 .59.164.742.428l6.535 11.32a.86.86 0 0 1 0 .856.859.859 0 0 1-.741.428H12.165Z"
      fill="#FF9595"
    />
    <Path
      d="M25.977 26.05a.86.86 0 0 0 0-.856l-6.535-11.32a.86.86 0 0 0-.742-.428v13.032h6.536c.305 0 .59-.164.741-.428Z"
      fill="#F46262"
    />
    <Path
      d="M18.7 24.74a.761.761 0 0 1-.76-.762v-.407a.761.761 0 1 1 1.522 0v.407c0 .42-.341.761-.761.761Z"
      fill="#fff"
    />
    <Path
      d="M19.462 23.978v-.407c0-.42-.341-.762-.762-.762v1.93c.42 0 .762-.34.762-.76Z"
      fill="#FFE7E7"
    />
    <Path
      d="M18.7 21.478a.761.761 0 0 1-.76-.76V17.59a.761.761 0 0 1 1.522 0v3.127c0 .42-.341.761-.761.761Z"
      fill="#fff"
    />
    <Path
      d="M19.462 20.717V17.59c0-.42-.341-.761-.762-.761v4.65c.42 0 .762-.342.762-.762Z"
      fill="#FFE7E7"
    />
  </Svg>
)

export default InEligibleBankAccout
